module.exports = __webpack_public_path__ + "1791188489487/images/brandbook-half-o-bottom.16281ed.svg";